import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "url(#a)",
                d: "M438.47 279.097c14.482-32.46-57.111-123.149-125.506-160.932-43.111-29.27-88.034-25.249-97.132-12.397-19.967 28.204 66.116 52.103 123.686 79.991-12.375 5.393-24.037 15.071-30.895 27.448-21.463-23.51-68.571-43.756-123.846-27.448-37.249 10.99-68.206 36.899-80.171 76.032a23.304 23.304 0 0 0-9.513-2.017c-12.95 0-23.447 10.534-23.447 23.527 0 12.994 10.498 23.527 23.447 23.527 2.4 0 9.906-1.615 9.906-1.615l119.931.872c-47.963 76.345-85.867 87.505-85.867 100.732 0 13.226 36.268 9.642 49.885 4.712 65.19-23.601 135.207-97.156 147.222-118.33 50.455 6.316 92.858 7.063 102.3-14.102Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "url(#b)",
                fillRule: "evenodd",
                d: "m339.513 185.763.009.004c2.669-1.055 2.237-5.009 1.504-8.115-1.684-7.137-30.742-35.928-58.029-48.823-37.182-17.572-64.562-16.666-68.607-8.567 7.574 15.575 42.687 30.199 79.358 45.471 15.646 6.516 31.575 13.15 45.771 20.027l-.006.003Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "url(#c)",
                fillRule: "evenodd",
                d: "M292.329 342.523c-7.52-2.883-16.014-5.529-25.671-7.929 10.297-18.486 12.457-45.854 2.733-63.157-13.648-24.284-30.779-37.209-70.589-37.209-21.895 0-80.847 7.4-81.893 56.778-.11 5.181-.003 9.929.371 14.295l107.65.783c-14.513 23.101-28.105 40.234-40.004 53.261 14.287 3.674 26.077 6.758 36.902 9.589 10.27 2.686 19.671 5.145 29.511 7.664 14.843-10.85 28.796-22.681 40.99-34.075Z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "url(#d)",
                d: "M103.169 300.228c4.398 37.509 25.644 52.209 69.058 56.56 43.414 4.35 68.317 1.432 101.471 4.458 27.691 2.528 52.415 16.686 61.587 11.794 8.254-4.404 3.636-20.312-7.409-30.519-14.318-13.23-34.134-22.428-69.001-25.693 6.949-19.089 5.002-45.855-5.79-60.417-15.604-21.056-44.405-30.575-80.858-26.416-38.084 4.345-74.577 23.158-69.058 70.233Z"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "a",
                        x1: 180.439,
                        x2: 435.479,
                        y1: 250.352,
                        y2: 322.433,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#8697FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#ABB7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "b",
                        x1: 392.428,
                        x2: 207.876,
                        y1: 245.489,
                        y2: 61.108,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#8697FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#5156D8",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "c",
                        x1: 297.446,
                        x2: 120.465,
                        y1: 348.967,
                        y2: 247.558,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#465EED"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 1,
                                stopColor: "#8697FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "d",
                        x1: 195.658,
                        x2: 315.581,
                        y1: 248.443,
                        y2: 400.306,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#8898FF"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: 0.984,
                                stopColor: "#6277F1"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
